import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showError } from 'actions/CommonActions';
import { formError, formInput, clearFormInput } from 'actions/FormActions';
import { transferProductToWarehouse, getProductInventoryByBranch, cleanProductInventoryByBranch, getProductsGroupedFromWarehouse, 
    clearSelectAdjustmentProduct, getPendingBulkTransferProducts, verifyCredential, clearVerifyCredential } from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import TextInput from 'screens/components/basic/TextInput';
import util from 'library/util';
import SelectInput from 'screens/components/basic/SelectInput';
import { mapWarehouseListTransfer } from 'utils/mappers';
import GenericTable from 'screens/components/advanced/GenericTable';
import { validateMaxInTextInput } from 'utils/helpers';
import DialogHeader from 'screens/components/basic/DialogHeader';
import DecimalInputOnePlace from 'screens/components/basic/DecimalInputOnePlace';
import DialogHeaderWithClose from '../../../components/basic/DialogHeaderWithClose';
import { selectVerifyCredentialModel } from '../../../../selectors/entitySelector';

const dialogStyle = {
    width: '70%',
    maxWidth: 'none'
};

class TransferProductDialog extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            open: false,
            warehouses: null,
            warehouseTypeItems: [
                {
                    text: 'Storage',
                    value: 1
                },
                {
                    text: 'Sell',
                    value: 2
                },
                {
                    text: 'Damage',
                    value: 3
                }
            ],
            transferToOtherBranches: false,
            pendingBulkTransferProducts: null,
            openDialogManagerApproval: false
        };
    }

    componentWillReceiveProps(newProps) {
        if (this.props.product !== newProps.product) {
            if (newProps.product) {
                this.setState({ open: true, warehouses: newProps.product.warehouses });

                let model = {
                    branchId: newProps.branchId,
                    productId: newProps.product.productId
                }
                this.props.getPendingBulkTransferProducts(model)
            } else {
                this.onClose();
            }
        }

        if (this.props.pendingBulkTransferProducts != newProps.pendingBulkTransferProducts && newProps.pendingBulkTransferProducts.length > 0) {
            this.setState({ pendingBulkTransferProducts: newProps.pendingBulkTransferProducts })
        }

        if (newProps.selectedRows !== null && newProps.selectedRows !== undefined) {
            if (newProps.selectedRows !== this.props.selectedRows) {
                if (newProps.selectedRows.length == 0) {
                    this.props.clearFormInput(this.props.name + 'Quantity')
                }
                let selectedWarehouse = newProps.selectedRows.length > 0 ? this.state.warehouses[newProps.selectedRows[0]] : [];

                let warehouseTypeItems = [];

                //TODO - Improve this
                //Calculate the Warehouse
                let branchQty = ((this.props.fromMIM && this.props.clickedBranch) || this.props.branchId) - 1; //Means like, if the store has 2 branches, the second branch will be 2. Reducing to 1 to multiply on the WH id

                if (selectedWarehouse.warehouseType === 1) {
                    warehouseTypeItems = [{
                        text: 'Store (Sell)',
                        value: (2 + (branchQty * 3))
                    },
                    {
                        text: 'Damage',
                        value: (3 + (branchQty * 3))
                    }];
                } else if (selectedWarehouse.warehouseType === 2) {
                    warehouseTypeItems = [{
                        text: 'Storage',
                        value: (1 + (branchQty * 3))
                    },
                    {
                        text: 'Damage',
                        value: (3 + (branchQty * 3))
                    }];
                } else {
                    warehouseTypeItems = [{
                        text: 'Storage',
                        value: (1 + (branchQty * 3))
                    },
                    {
                        text: 'Store (Sell)',
                        value: (2 + (branchQty * 3))
                    }];
                }

                if (newProps.branchTo != null && newProps.branchTo != newProps.branchId) {
                    warehouseTypeItems = [{
                        text: 'Storage',
                        value: (1 + ((newProps.branchTo - 1) * 3))
                    },
                    {
                        text: 'Store (Sell)',
                        value: (2 + ((newProps.branchTo - 1) * 3))
                    },
                    {
                        text: 'Damage',
                        value: (3 + ((newProps.branchTo - 1) * 3))
                    }];
                }
                this.setState({ warehouseTypeItems: warehouseTypeItems });
            }
        }

        if (newProps.branchTo != null && newProps.branchTo != undefined && newProps.branchTo != this.props.branchTo) {
            let warehouseTypeItems = [{
                text: 'Storage',
                value: (1 + ((newProps.branchTo - 1) * 3))
            },
            {
                text: 'Store (Sell)',
                value: (2 + ((newProps.branchTo - 1) * 3))
            },
            {
                text: 'Damage',
                value: (3 + ((newProps.branchTo - 1) * 3))
            }];
            this.setState({ warehouseTypeItems: warehouseTypeItems });

            let model = {
                ProductId: this.props.product.productId,
                branchId: newProps.branchTo,
                type: LOOKUP.ProductInventoryByBranchType.branchTo
            };
            this.props.getProductInventoryByBranch(model);
        }

        if (newProps.branchFrom != null && newProps.branchFrom != undefined && newProps.branchFrom != this.props.branchFrom) {
            this.props.clearFormInput(`transferTableSelectedRows`);
            this.props.clearFormInput(`transferProductDialogBranchTo`);
            this.props.clearFormInput(`transferProductDialogBranchToText`);
            let model = {
                ProductId: this.props.product.productId,
                branchId: newProps.branchFrom,
                type: LOOKUP.ProductInventoryByBranchType.branchFrom
            };
            this.props.getProductInventoryByBranch(model);

            const warehouseModel = {
                page: 1,
                itemsPerPage: 20,
                warehouseId: null,
                productName: '',
                categoryId: null,
                quantity: null,
                branchId: newProps.branchFrom,
                productId: this.props.product.productId
            }

            this.props.getProductsGroupedFromWarehouse(warehouseModel);
        }

        if (newProps.isCredentialAuthorized && newProps.isCredentialAuthorized != this.props.isCredentialAuthorized) {
            this.closeDialogManagerApproval();
            this.enableOtherBranchSelect();
        }
    }

    componentWillUnmount() {
        this.props.clearFormInput(`transferTableSelectedRows`);
        this.props.clearFormInput(`transferProductDialogWarehouseToText`);
        this.props.clearFormInput(`transferProductDialogBranchTo`);
        this.props.clearFormInput(`transferProductDialogBranchToText`);
        this.props.clearFormInput(`transferProductDialogBranchFrom`);
        this.props.clearFormInput(`transferProductDialogBranchFromText`);
        this.props.clearFormInput(`transferProductDialogIsReceiveFromAnotherBranch`);
        this.props.cleanProductInventoryByBranch();
    }

    confirmTransfer = () => {
        let p = this.props;

        //Getting the warehouse selected row
        let selectedWarehouse = null;
        if (this.props.selectedRows !== null && this.props.selectedRows !== undefined) {
            selectedWarehouse = this.state.warehouses[this.props.selectedRows[0]];
        } else {
            this.props.showError("Please select the warehouse you want to transfer FROM");
            return;
        }
        let model = {};

        if (this.props.warehouseTo == null || this.props.warehouseTo == '') {
            this.props.showError("Please select the warehouse you want to transfer to");
            return;
        }

        if (this.props.quantity == null || this.props.quantity == '') {
            this.props.showError("Please select the quantity you want to transfer");
            return;
        }

        if (this.props.branchTo != null && this.props.branchFrom != null && this.props.branchTo != this.props.branchFrom) {
            model = {
                quantity: this.props.quantity,
                productID: this.props.product.productId,
                packageReference: selectedWarehouse ? selectedWarehouse.packageReference : '',
                fromWarehouse: selectedWarehouse ? selectedWarehouse.warehouseId : null,
                toWarehouse: this.props.warehouseTo,
                branchId: this.props.branchId,
                reason: 11 //11 = TransferBetweenBranches
            };
        }
        else if (this.props.branchTransferManuallyReceive && this.props.isReceiveFromAnotherBranch) {
            model = {
                quantity: this.props.quantity,
                productID: this.props.product.productId,
                packageReference: selectedWarehouse ? selectedWarehouse.packageReference : '',
                fromWarehouse: selectedWarehouse ? selectedWarehouse.warehouseId : null,
                toWarehouse: this.props.warehouseTo,
                branchId: this.props.branchId,
                reason: 12 //12 = ReceiveTransferFromAnotherBranch
            };
        }
        else {
            model = {
                quantity: this.props.quantity,
                productID: this.props.product.productId,
                packageReference: selectedWarehouse ? selectedWarehouse.packageReference : '',
                fromWarehouse: selectedWarehouse ? selectedWarehouse.warehouseId : null,
                toWarehouse: this.props.warehouseTo,
                branchId: this.props.branchId,
                reason: 1 //1 = Transfer
            };
        }

        const validators = [
            [p.name + 'Quantity', model => (model.quantity !== null && model.quantity !== "" && model.quantity >= 0), "Quantity"],
            [p.name + 'WarehouseTo', model => (model.toWarehouse !== null && model.toWarehouse !== ""), "WarehouseTo"]
        ];

        if (util.validate(validators, model, this.props.formError)) {
            this.props.transferProductToWarehouse(model);
            this.onClose();
        }
    }

    onClose = () => {
        this.props.onClose();
        this.props.formInput(this.props.name + 'WarehouseTo', null);
        this.props.formError(this.props.name + 'WarehouseTo', null);
        this.props.formInput(this.props.name + 'Quantity', null);
        this.props.formError(this.props.name + 'Quantity', null);
        this.props.formInput("transferTableSelectedRows", null);
        this.setState({ open: false });
    }

    enableOtherBranchSelect = () => {
        this.setState({
            transferToOtherBranches: true
            });
    
        this.props.formInput('transferProductDialogBranchFrom', this.props.branchId);
        this.props.formInput('transferProductDialogBranchFromText', this.props.branchName);
    }

    clearCredentialDialog = () => {
        this.props.clearFormInput(`${this.props.name}UserName`);
        this.props.clearFormInput(`${this.props.name}Password`);
        this.props.clearFormInput(`${this.props.name}PinCode`);
        this.props.clearVerifyCredential();
    }

    openDialogManagerApproval = () => {
        this.clearCredentialDialog();
        this.setState({
            openDialogManagerApproval: true
        })
    }

    closeDialogManagerApproval = () => {
        this.setState({
            openDialogManagerApproval: false
        })
    }

    verifyCredential = () => {
        this.props.verifyCredential(this.props.verifyCredentialModel);
    }

    render() {
        const p = this.props;
        const s = this.state;

        const actions = [
            <Button
                key={1}
                type="CancelButton"
                className="btn-space btnCleanSearch"
                label={LOOKUP.common.cancel.text}
                secondary={true}
                onTouchTap={() => this.onClose()}
            />,
            <Button
                key={2}
                className="pull-right btn-space btnNewBrandPOS"
                type="RaisedButton"
                id="confirmTransfer"
                label={"Confirm"}
                onTouchTap={() => this.confirmTransfer()}
            />
        ];

        let product = p.product;
        let warehouses = [];
        if (this.state.warehouses !== null && this.state.warehouses !== undefined) {
            warehouses = this.state.warehouses;
        }

        let pendingBulkTransferProducts = [];
        if (this.state.pendingBulkTransferProducts !== null && this.state.pendingBulkTransferProducts !== undefined) {
            pendingBulkTransferProducts = this.state.pendingBulkTransferProducts;
        }

        let row = this.props.selectedRows;

        let transferTableRows = mapWarehouseListTransfer(warehouses, pendingBulkTransferProducts);

        return (
            <div>
                <DialogInput
                    title={<DialogHeaderWithClose text="Transfer Product" classicClass="posDialogClassic" handleClose={() => this.onClose()} />}
                    actions={actions}
                    modal={true}
                    className="transfer_Product"
                    open={s.open}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}>
                    <div className="transferProducts">
                        <div>
                            <div className="form-group">

                                <div className="row m-0 product-info-modal-transfer">
                                    <div className="col-lg-6">
                                        <h4>{product ? product.productName : ''}</h4>
                                        <p>
                                            {product ? `SKU: ${product.productSKU}` : ''}<br />
                                            {product ? `${product.productType} - ${product.productCategory}` : ''}
                                        </p>
                                    </div>
                                    {this.props.multipleBranches && this.props.canTransferBetweenBranches ?
                                        <div className='col-lg-6'>
                                            <Button
                                                key={2}
                                                className="pull-right btn-space btnNewBrandPOS"
                                                type="RaisedButton"
                                                id="buttonTransferBetweenBranches"
                                                label={"Transfer Between Branches"}
                                                onTouchTap={() => this.openDialogManagerApproval()}
                                            />
                                        </div> : null
                                    }

                                </div>
                                {
                                    this.state.transferToOtherBranches ?
                                        <div className="row m-0">
                                            <div className="col-lg-12">
                                                <SelectInput
                                                    name={`${this.props.name}BranchFrom`}
                                                    fullWidth={true}
                                                    id="selectFromBranch"
                                                    label={`From which Branch?`}
                                                    floatingLabelText={`From which Branch?`}
                                                    options={this.props.allBranches}
                                                    hintText={`From which Branch?`} />
                                            </div>
                                        </div> : ""
                                }

                                {
                                    this.props.productInventoryByBranchFrom &&
                                    <div className="row m-0 border_bottom_grey">
                                        <div className="col-lg-12 purpleText">
                                            <h4>Source Branch Inventory Level:</h4>
                                        </div>
                                        <br />
                                        <div className="col-lg-12">
                                            <h5>Total Quantity (Storage + Store + Damage): {this.props.productInventoryByBranchFrom.totalQuantity}</h5>
                                        </div>
                                        <div className="col-lg-12">
                                            <h5>Storage Quantity: {this.props.productInventoryByBranchFrom.totalStorageQuantity}</h5>
                                        </div>
                                        <div className="col-lg-12">
                                            <h5>Store Quantity: {this.props.productInventoryByBranchFrom.totalStoreQuantity}</h5>
                                        </div>
                                        <div className="col-lg-12 mb-1">
                                            <h5>Damage Quantity: {this.props.productInventoryByBranchFrom.totalDamageQuantity}</h5>
                                        </div>
                                    </div>
                                }
                                {
                                    ((!this.state.transferToOtherBranches) || (this.props.productInventoryByBranchFrom && this.props.productInventoryByBranchFrom.totalQuantity > 0)) &&
                                    <div className="row m-0">
                                        <div className="col-lg-12">
                                            <h4>From which Warehouse?</h4>
                                            <GenericTable
                                                className="table-inventory"
                                                compName="transferTable"
                                                tableHeaderClassName="table-products-header"
                                                tableBodyClassName="table-products"
                                                adjustForCheckbox={true}
                                                displaySelectAll={false}
                                                displayRowCheckbox={true}
                                                enableSelectAll={false}
                                                multiSelectable={false}
                                                selectable={true}
                                                columns={LOOKUP.transferProduct.tableColumnsWarehouseTransfer}
                                                rows={transferTableRows}
                                            />
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.transferToOtherBranches ?
                                        <div className="row m-0">
                                            <div className="col-lg-12">
                                                <SelectInput
                                                    name={`${this.props.name}BranchTo`}
                                                    fullWidth={true}
                                                    id="selectToBranch"
                                                    label={`To which Branch?`}
                                                    floatingLabelText={`To which Branch?`}
                                                    options={this.props.allBranches}
                                                    hintText={`To which Branch?`} />
                                            </div>
                                        </div> : ""
                                }
                                {
                                    this.props.productInventoryByBranchTo &&
                                    <div className="row m-0 border_bottom_grey">
                                        <div className="col-lg-12">
                                            <h4 className="purpleText">Target Branch Inventory Level:</h4>
                                        </div>
                                        <br />
                                        <div className="col-lg-12">
                                            <h5 className="purpleText">Total Quantity (Storage + Store + Damage): {this.props.productInventoryByBranchTo.totalQuantity}</h5>
                                        </div>
                                        <div className="col-lg-12">
                                            <h5 className="purpleText">Storage Quantity: {this.props.productInventoryByBranchTo.totalStorageQuantity}</h5>
                                        </div>
                                        <div className="col-lg-12">
                                            <h5>Store Quantity: {this.props.productInventoryByBranchTo.totalStoreQuantity}</h5>
                                        </div>
                                        <div className="col-lg-12 mb-1">
                                            <h5 className="purpleText">Damage Quantity: {this.props.productInventoryByBranchTo.totalDamageQuantity}</h5>
                                        </div>
                                    </div>
                                }

                                <div className="row m-0">
                                    <div className="col-lg-12">
                                        <SelectInput
                                            name={`${this.props.name}WarehouseTo`}
                                            fullWidth={true}
                                            id="selectWarehouseTo"
                                            label={`To which Warehouse?`}
                                            floatingLabelText={`To which Warehouse?`}
                                            options={this.state.warehouseTypeItems}
                                            hintText={`To which Warehouse?`} />
                                    </div>
                                </div>

                                <div className="row m-0">
                                    <div className="col-lg-12">
                                        {
                                            this.props.isMedical ?
                                                <div>
                                                    <DecimalInputOnePlace name={`${this.props.name}Quantity`}
                                                        hintText={"Quantity to transfer"}
                                                        type="number"
                                                        fullWidth={true}
                                                        label="Quantity to transfer"
                                                        floatingLabelText="Quantity to transfer"
                                                        onInput={(e) => validateMaxInTextInput(e, (row !== null && row !== undefined && row.length > 0 ? warehouses[row[0]].quantity : null))}
                                                    />
                                                </div>
                                                :
                                                <div>
                                                    <TextInput name={`${this.props.name}Quantity`}
                                                        hintText={"Quantity to transfer"}
                                                        type="number"
                                                        fullWidth={true}
                                                        label="Quantity to transfer"
                                                        floatingLabelText="Quantity to transfer"
                                                        onInput={(e) => validateMaxInTextInput(e, (row !== null && row !== undefined && row.length > 0 ? warehouses[row[0]].quantity : null))}
                                                    />
                                                </div>
                                        }
                                        {
                                            row !== null && row !== undefined && row.length > 0 && (this.props.quantity == 0 ? false : transferTableRows[row].pendingTransfer > transferTableRows[row].quantity - parseInt(this.props.quantity)) &&
                                            <h5 className="orange-text">Warning: If the quantity after transfer is below the pending outward quantity, it may prevent bulk transfers from being completed.</h5>
                                        }
                                    </div>
                                    {
                                        this.props.warehouseTo && this.props.warehouseTo % 3 == 2 && this.props.branchTransferManuallyReceive && (
                                            <div className="col-lg-12">
                                                <span className="purpleText">Are you Receiving transfer from another branch?</span>
                                                <ToggleInput name={`${this.props.name}IsReceiveFromAnotherBranch`} className="legalBarcode btnToggleLabel" />
                                            </div>
                                        )
                                    }
                                </div>


                            </div>
                        </div>
                    </div>
                </DialogInput>
                <DialogInput
                    title={<div className="modal-title p-0">
                        <DialogHeader text="Transfer Between Branches" classicClass="posDialogClassic" /></div>}
                    autoScrollBodyContent={true}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label="Cancel"
                            onTouchTap={() => this.closeDialogManagerApproval()} />,
                        <Button
                            key={2}
                            name="buttonRemoveItem"
                            label="Confirm"
                            primary={true}
                            className="btnNewBrandPOS"
                            onTouchTap={() => this.verifyCredential()} />]}
                    modal={true}
                    open={this.state.openDialogManagerApproval}>
                    <div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="alert alert-danger">
                                    <p className="purpleText">Are you sure you want to transfer between branches? Administrative approval is required to activate transfer between branches. To accept enter your admin user name and password or pin.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <h4><b>Management Team Credential</b></h4>
                        <div className="row">
                            <div className="col-lg-12">
                                <TextInput
                                    name={`${this.props.name}UserName`}
                                    fullWidth={true}
                                    label="Management Team User Name"
                                    floatingLabelText="Management Team User Name"
                                    hintText="Management Team User Name"
                                    autoComplete="off" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <TextInput
                                    name={`${this.props.name}Password`}
                                    type="password"
                                    fullWidth={true}
                                    label="Management Team Password"
                                    floatingLabelText="Management Team Password"
                                    hintText="Management Team Password"
                                    autoComplete="off" />
                            </div>
                        </div>
                        <div>
                            <h4 className="purpleText"><b>Or By Pin Code</b></h4>
                            <div className="row">
                                <div className="col-lg-12">
                                    <TextInput
                                        name={`${this.props.name}PinCode`}
                                        hintText="PinCode"
                                        label="Pin Code"
                                        fullWidth={true}
                                        type="password"
                                        maxLength={4}
                                        autoComplete="off" />
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogInput>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let allBranches = [];
    if (state.common.userBranches != null && state.common.userBranches.length > 1 && state.common.branchId != null) {
        for (let i = 0; i < state.common.userBranches.length; i++) {
            allBranches.push({
                text: state.common.userBranches[i].name,
                value: state.common.userBranches[i].id
            })
        }
    }
    return {
        branchId: state.common.branchId,
        branchName: state.common.store.name,
        product: state.entity.productForAdjustment,
        selectedRows: state.form["transferTableSelectedRows"],
        quantity: state.form[`${ownProps.name}Quantity`] ? parseFloat(state.form[`${ownProps.name}Quantity`]) : null,
        warehouseTo: state.form[`${ownProps.name}WarehouseTo`] ? parseFloat(state.form[`${ownProps.name}WarehouseTo`]) : null,
        multipleBranches: state.common.userBranches ? state.common.userBranches.length > 1 ? true : false : false,
        allBranches: allBranches,
        branchTo: state.form[`transferProductDialogBranchTo`] ? parseFloat(state.form[`transferProductDialogBranchTo`]) : null,
        branchFrom: state.form[`transferProductDialogBranchFrom`] ? parseFloat(state.form[`transferProductDialogBranchFrom`]) : null,
        branchTransferManuallyReceive: state.common.applicationSettings.branchTransferManuallyReceive,
        isReceiveFromAnotherBranch: state.form[`${ownProps.name}IsReceiveFromAnotherBranch`] ? state.form[`${ownProps.name}IsReceiveFromAnotherBranch`] : false,
        productInventoryByBranchTo: state.entity.productInventoryByBranchTo,
        productInventoryByBranchFrom: state.entity.productInventoryByBranchFrom,
        isMedical: state.common.applicationSettings.isMedical,
        pendingBulkTransferProducts: state.entity.pendingBulkTransferProducts,
        canTransferBetweenBranches: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanTransferBetweenBranches")),
        verifyCredentialModel: selectVerifyCredentialModel(state, "InventoryPolicies.CanTransferBetweenBranches", ownProps.name),
        isCredentialAuthorized: state.entity.isCredentialAuthorized,
        clickedBranch: state.form.clickedBranch
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formError: (name, error) => dispatch(formError(name, error)),
        formInput: (name, value) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        transferProductToWarehouse: (model) => dispatch(transferProductToWarehouse(model)),
        getProductInventoryByBranch: (model) => dispatch(getProductInventoryByBranch(model)),
        cleanProductInventoryByBranch: () => dispatch(cleanProductInventoryByBranch()),
        getProductsGroupedFromWarehouse: (model) => dispatch(getProductsGroupedFromWarehouse(model)),
        clearSelectAdjustmentProduct: () => dispatch(clearSelectAdjustmentProduct()),
        getPendingBulkTransferProducts: (model) => dispatch(getPendingBulkTransferProducts(model)),
        verifyCredential: (model) => dispatch(verifyCredential(model)),
        clearVerifyCredential: () => dispatch(clearVerifyCredential())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferProductDialog);
